import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import UtilityBar from "./UtilityBar";
import Header from "./Header";
import Footer from "./Footer";
import MobileBottomBar from "./MobileBottomBar";
import FloatingActions from "./FloatingActions";
import { SettingsContext } from "./SettingsContext";
import { fetchSettings } from "../../lib/lnlApi";
import { applyTheme } from "../../lib/theme";

// Re-export for backwards compatibility — older imports used
// `import { SettingsContext } from "@/components/layout/PublicLayout"`.
// New code should import directly from "./SettingsContext".
export { SettingsContext };

export default function PublicLayout() {
    const [settings, setSettings] = useState(null);
    useEffect(() => {
        fetchSettings().then((s) => {
            setSettings(s);
            if (s?.theme) applyTheme(s.theme);
        }).catch(() => setSettings({
            official_name: "Lyceum Northern Luzon", abbreviation: "LNL",
            address_line: "MacArthur Highway, San Vicente, Urdaneta City",
            province_line: "Pangasinan 2428, Philippines", mobile: "0916-330-3184",
            email_info: "info@lyceumnorthernluzon.edu.ph",
            email_registrar: "registrar@lyceumnorthernluzon.edu.ph",
            portal_url: "https://lnl.wela.ph",
            library_url: "https://library.lyceumnorthernluzon.edu.ph",
            opac_url: "https://opac.lyceumnorthernluzon.edu.ph",
            academic_year: "AY 2026–2027", enrollment_status: "Admissions Now Open",
            established_year_draft: "1994",
            logo_url: "https://customer-assets-eiarnc6j.emergentagent.net/job_lnl-admissions/artifacts/vbylfelw_Lyceum%20logo.jpg",
            map_query: "Lyceum Northern Luzon Urdaneta",
        }));
    }, []);

    return (
        <SettingsContext.Provider value={settings}>
            <div className="min-h-screen flex flex-col bg-white lnl-mobile-bottom-safe">
                <UtilityBar settings={settings} />
                <Header settings={settings} />
                <main className="flex-1"><Outlet /></main>
                <Footer settings={settings} />
                <MobileBottomBar settings={settings} />
                <FloatingActions />
                <Toaster richColors position="top-center" />
            </div>
        </SettingsContext.Provider>
    );
}
